export default "__VITE_ASSET__BBG0c$wG__"